import React from 'react'

import RegistrationButton from './RegistrationButton'
import LoginButton from './LoginButton'

const LoggedOffHeader = () => {
  return (
    <div className='header__buttons'>
      <RegistrationButton />
      <LoginButton />
    </div>
  )
}

export default LoggedOffHeader



// WEBPACK FOOTER //
// ./src/components/Header/LoggedOffHeader/index.js